import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from './Button';

class ButtonIcon extends Component {
  static propTypes = {
    pos: PropTypes.string,
    icon: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string
  };

  static defaultProps = {
    pos: 'left',
    id: ''
  };

  render() {
    const { children, className, icon, pos, id, ...props } = this.props;
    const iconClass = classNames('icon', `icon-${icon}`);
    const classComponent = classNames(className, 'button__icon', {
      button__icon__left: pos === 'left',
      button__icon__right: pos === 'right'
    });

    return (
      <Button className={classComponent} {...props} type="button">
        {(pos === 'left' || pos === 'center') && <i className={iconClass} />}
        {children && (
          <div id={id} className="text">
            {children}
          </div>
        )}
        {pos === 'right' && <i className={iconClass} />}
      </Button>
    );
  }
}

export default ButtonIcon;
